/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { TRANSLATE_THIS_BLOCK_BY_WEGLOT } from "i18n/weglot";
import React from "react";

import { sanitizer } from "../../utility/sanitize";

import type { SerializedStyles } from "@emotion/react";

type Props = {
  description: string;
  isDarkModeEnabled: boolean;
  overrideCss?: SerializedStyles;
};

export const StreamingEventDescriptionBody: React.FC<Props> = (props) => {
  const { description, isDarkModeEnabled, overrideCss } = props;
  const classes = styles({ isDarkModeEnabled });
  const applyCssList = [classes.description, overrideCss].filter(Boolean);

  return (
    <p
      className={TRANSLATE_THIS_BLOCK_BY_WEGLOT}
      css={applyCssList}
      dangerouslySetInnerHTML={{ __html: sanitizer(description) }}
    />
  );
};

const styles = (props: { isDarkModeEnabled: boolean }) => {
  const textColorInDarkMode = props.isDarkModeEnabled
    ? css`
        color: #fff;
      `
    : null;

  return {
    description: css`
      ${textColorInDarkMode};
      font-size: 14px;
      line-height: 1.5em;
      letter-spacing: 1px;
      img {
        max-width: 100%;
      }
      a {
        color: #00c2ae;
      }
    `,
  };
};
